export const isBrowser = typeof window !== "undefined";
export const iS_PRODUCTION = process.env.NODE_ENV === "production";
export const SMALL_MOBILE_BREAKPOINT = "(max-width: 599.98px)";
export const MOBILE_BREAKPOINT = "(max-width: 767.98px)";
export const TABLET_BREAKPOINT = "(min-width: 768px) and (max-width: 991.98px)";
export const DESKTOP_BREAKPOINT = "(min-width: 992px)";